import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

interface ErrorReceivedProperties {
  error_type: string;
}

interface SharedDevicePromptAnsweredProperties {
  answer: 'yes' | 'no';
}

export const createAuthCaptureEvents = (posthog: PostHogInstance) => ({
  loggedOut: () => {
    posthog?.capture('auth / logged out');
  },
  loginAccessCodeErrorReceived: (properties: ErrorReceivedProperties) => {
    posthog?.capture('auth / login / access code / error received', properties);
  },
  loginAccessCodeRerequested: () => {
    posthog?.capture('auth / login / access code / rerequested');
  },
  loginAccessCodeSubmitted: () => {
    posthog?.capture('auth / login / access code / submitted');
  },
  loginEmailErrorReceived: (properties: ErrorReceivedProperties) => {
    posthog?.capture('auth / login / email / error received', properties);
  },
  loginEmailSubmitted: () => {
    posthog?.capture('auth / login / email / submitted');
  },
  sharedDevicePromptShown: () => {
    posthog?.capture('auth / shared device / prompt / shown');
  },
  sharedDevicePromptAnswered: (
    properties: SharedDevicePromptAnsweredProperties
  ) => {
    posthog?.capture('auth / shared device / prompt / answered', properties);
  },
  sharedDeviceSwitchAccountClicked: () => {
    posthog?.capture('auth / shared device / switch accounts / clicked');
  },
  inactivityLoggedOut: () => {
    posthog?.capture('auth / inactivity / logged out');
  },
});

export type AuthCaptureEvents = ReturnType<typeof createAuthCaptureEvents>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createAuthCaptureEvents(posthog), [posthog]);
};
